// src/hooks/useInitAuthCookie.ts
import { useEffect, useState } from "react";
import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
  isJwtExpired,
} from "src/utils/tokenCookie";

const BASE_URL = process.env.REACT_APP_OMS_SERVER_API || "http://localhost:8080";

export function useInitAuthCookie() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const at = getAccessToken();

        // accessToken 없으면 localStorage도 정리하고 비로그인으로 초기화 완료
        if (!at) {
          // localStorage와 쿠키 동기화 (쿠키 없으면 localStorage도 정리)
          localStorage.removeItem("accessToken");
          localStorage.removeItem("userId");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userName");
          localStorage.removeItem("loginType");
          return;
        }

        // accessToken이 만료됐으면 refresh 시도
        if (isJwtExpired(at)) {
          const rt = getRefreshToken();
          if (!rt) throw new Error("NO_REFRESH_TOKEN");

          const res = await axios.post(
            `${BASE_URL}/v1/admin/auth/refresh`,
            { refreshToken: rt },
            { headers: { "Content-Type": "application/json" } }
          );

          const { accessToken, refreshToken } = res.data?.data || {};
          if (!accessToken) throw new Error("INVALID_REFRESH_RESPONSE");

          setTokens(accessToken, refreshToken);
        }
      } catch {
        // refresh 실패면 토큰 정리 (라우팅은 App에서 자연스럽게 /login으로 이동)
        clearTokens();
        // localStorage도 정리
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userName");
        localStorage.removeItem("loginType");
      } finally {
        if (alive) setInitialized(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return initialized;
}
